class DeliveryAndReturn extends HTMLElement {
  constructor() {
    super();
    this.modal = document.getElementById('bt-delivery-return-modal');
    this.selectors = {
      openBtn: '[data-open-delivery-return]',
    };

    MicroModal.init();
  }

  connectedCallback() {
    if (this.modal) {
      this.init();
    }
  }

  init() {
    addEventDelegate({
      selector: this.selectors.openBtn,
      handler: (e) => {
        e.preventDefault();
        MicroModal.show(this.modal.id, {
          onShow: (modal) => {
            document.body.classList.add('bt-opened-modal');
          },
          onClose: (modal) => {
            document.body.classList.remove('bt-opened-modal');
          },
        });
      },
    });
  }
}
customElements.define('bt-delivery-return', DeliveryAndReturn);
